"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var Tab = react_2.default.memo(function (_a) {
    var id = _a.id, panelId = _a.panelId, tabLabel = _a.label, to = _a.to, onClick = _a.onClick, errors = _a.errors, classes = _a.classes, rest = __rest(_a, ["id", "panelId", "label", "to", "onClick", "errors", "classes"]);
    var classesMain = (0, styles_1.useStyles)({ errors: errors });
    return ((0, jsx_runtime_1.jsx)(core_1.Tab, __assign({}, rest, { id: id, "aria-controls": panelId, label: tabLabel, classes: { root: classesMain.root, selected: classesMain.selected }, onClick: function (event) { return onClick && onClick({ event: event, to: to }); } })));
});
exports.Tabs = react_2.default.memo(function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, onChange = _a.onChange, label = _a.label, tabs = _a.tabs;
    var classesMain = (0, styles_1.useBaseStyles)({ errors: false });
    return ((0, jsx_runtime_1.jsx)(core_1.Tabs, __assign({ value: value, onChange: onChange !== null && onChange !== void 0 ? onChange : onChange, "aria-label": label, classes: { root: classesMain.base, indicator: classesMain.indicator }, onClick: function () { } }, { children: tabs.map(function (_a) {
            var rest = __rest(_a, []);
            return (
            // TODO: future use should allow us to provide component and component props to support <Link />
            (0, react_1.createElement)(Tab, __assign({}, rest, { key: rest.id })));
        }) })));
});
